export default function ChevronCompactRightIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.61816 16.8882C9.54622 17.0708 9.43278 17.2174 9.27783 17.3281C9.12288 17.4443 8.9541 17.5024 8.77148 17.5024C8.46159 17.5024 8.2098 17.4028 8.01611 17.2036C7.82243 17.0099 7.72559 16.772 7.72559 16.4897C7.72559 16.3403 7.75879 16.1771 7.8252 16C7.8916 15.8229 7.95524 15.6624 8.01611 15.5186L10.4648 9.45898V10.5215L8.01611 4.45361C7.95524 4.31527 7.8916 4.15755 7.8252 3.98047C7.75879 3.79785 7.72559 3.63184 7.72559 3.48242C7.72559 3.2002 7.82243 2.96224 8.01611 2.76855C8.2098 2.57487 8.46159 2.47803 8.77148 2.47803C8.9541 2.47803 9.12288 2.53337 9.27783 2.64404C9.43278 2.75472 9.54622 2.90137 9.61816 3.08398L11.9009 8.68701C11.9894 8.90837 12.0724 9.12972 12.1499 9.35107C12.2274 9.56689 12.2661 9.77995 12.2661 9.99023C12.2661 10.195 12.2274 10.408 12.1499 10.6294C12.0724 10.8452 11.9894 11.0638 11.9009 11.2852L9.61816 16.8882Z" />
    </svg>
  );
}
